export default [
    {
        path: '',
        name: 'changlvmember',
        meta: {
            title: '开通长律会员'
        },
        component: () => import('@/views/changlvmember/index.vue')
    },
    {
        path: 'payResult',
        name: 'changlvmemberResult',
        meta: {
            title: '支付'
        },
        component: () => import('@/views/changlvmember/payResult.vue')
    }
]
